import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Paper,
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Navbar from "../CommonC/SelexSolNavbar";
import { baseURL } from "../../Config/config";

function PreviewNewsLetter() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [previewHtml, setPreviewHtml] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchPreview = async () => {
      try {
        setLoading(true);
        setError("");

        const response = await fetch(
          `${baseURL}/admin/newsletters/${id}/preview`,
          {
            method: "GET",
            credentials: "include",
          }
        );

        const data = await response.json();

        if (!response.ok || !data.success) {
          throw new Error(
            data.message || "Unable to load newsletter preview."
          );
        }

        setPreviewHtml(data.html);
      } catch (err) {
        console.error("Preview error:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPreview();
  }, [id]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "#f1f5f9",
      }}
    >
      <Navbar admin={true} />

      <Box
        sx={{
          maxWidth: "1100px",
          margin: "30px auto",
          padding: "0 20px",
        }}
      >
        {/* HEADER */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: "28px",
                fontWeight: 700,
                color: "#062a4f",
              }}
            >
              Newsletter Preview
            </Typography>

            <Typography
              sx={{
                fontSize: "14px",
                color: "#64748b",
                mt: 1,
              }}
            >
              Review your newsletter before sending it to clients.
            </Typography>
          </Box>

          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate("/adminhome")}
            sx={{
              textTransform: "none",
              borderRadius: "10px",
              borderColor: "#0078c9",
              color: "#0078c9",
            }}
          >
            Back to AdminHome
          </Button>
        </Box>

        {/* PREVIEW CONTENT */}
        <Paper
          elevation={0}
          sx={{
            borderRadius: "18px",
            overflow: "hidden",
            minHeight: "600px",
            boxShadow: "0 8px 30px rgba(0,0,0,0.06)",
          }}
        >
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "500px",
              }}
            >
              <CircularProgress />
            </Box>
          ) : error ? (
            <Typography
              color="error"
              sx={{ textAlign: "center", p: 5 }}
            >
              {error}
            </Typography>
          ) : (
           <iframe
  title="Newsletter Preview"
  srcDoc={previewHtml}
  sandbox="allow-popups allow-popups-to-escape-sandbox"
  referrerPolicy="no-referrer"
  style={{
    width: "100%",
    height: "750px",
    border: "none",
    background: "#ffffff",
  }}
/>
          )}
        </Paper>
      </Box>
    </Box>
  );
}

export default PreviewNewsLetter;